import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TypoFramed from '../../components/TypoFramed';

import styles from './styles';

class B4Numbers extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.bgImg}>
          <div className={classes.square}></div>
          <div className={classes.blur}></div>
        </div>
        <div className={classes.bgImg2}>
          <div className={classes.square2}></div>
        </div>
      </div>
    );
  }

  renderContent() {
    const { classes, data } = this.props;

    return (
      <div className={classes.content}>
        <div className={`${classes.col} ${classes.col1}`}>
          <div className={classes.group}>
            <div className={classes.blue}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText1}`}>
                Cahiers
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col1info1)}
              </Typography>
            </div>
            <div className={classes.blue}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText2}`}>
                Journées
              </Typography>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText3}`}>
                Professionnelles
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col1info2)}
              </Typography>
            </div>
          </div>
        </div>
        <div className={`${classes.col} ${classes.col2}`}>
          <div className={classes.group}>
            <div className={classes.red}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText4}`}>
                Travaux
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col2info1)}
              </Typography>
            </div>
            <div className={classes.red}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText5}`}>
                Demandes
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col2info2)}
              </Typography>
            </div>
          </div>
          <div className={classes.blue}>
            <div className={classes.infoLine}>
              <div>
                <Typography variant="h2" className={`${classes.bgText} ${classes.bgText6}`}>
                  Actualités
                </Typography>
                <Typography variant="h2" className={`${classes.bgText} ${classes.bgText7}`}>
                  Habitat
                </Typography>
                <Typography
                  variant="body2"
                  className={`bullet ${classes.bulletInfoline} ${classes.group} ${classes.text}`}
                >
                  {parse(data.blocks.b4numbers.col2info3_1)}
                </Typography>
              </div>
              <div>
                <Typography variant="body2" className={classes.text}>
                  {parse(data.blocks.b4numbers.col2info3_2)}
                </Typography>
              </div>
              <div>
                <Typography variant="body2" className={classes.text}>
                  {parse(data.blocks.b4numbers.col2info3_3)}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className={`${classes.col} ${classes.col3}`}>
          <div className={classes.group}>
            <div className={classes.blueLight}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText8}`}>
                Abon-
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col3info1)}
              </Typography>
            </div>
            <div className={classes.blueLight}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText9}`}>
                nés
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col3info2)}
              </Typography>
            </div>
            <div className={classes.blueLight}>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col3info3)}
              </Typography>
            </div>
          </div>
          <div className={classes.group}>
            <div className={classes.green}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText10}`}>
                Amen-
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col3info4)}
              </Typography>
            </div>
            <div className={classes.green}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText11}`}>
                dements
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col3info5)}
              </Typography>
            </div>
          </div>
        </div>
        <div className={`${classes.col} ${classes.col4}`}>
          <div className={classes.group}>
            <div className={classes.purpleLight}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText12}`}>
                Site
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bulletPurple}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col4info1)}
              </Typography>
            </div>
            <div className={classes.purpleLight}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText13}`}>
                Logement
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bulletPurple}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col4info2)}
              </Typography>
            </div>
            <div className={classes.purpleLight}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText14}`}>
                Hlm info
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bulletPurple}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col4info3)}
              </Typography>
            </div>
            <div className={classes.purpleLight}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText15}`}>
                Emploi
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bulletPurple}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col4info4)}
              </Typography>
            </div>
          </div>
        </div>
        <div className={`${classes.col} ${classes.col5}`}>
          <div className={classes.group}>
            <div className={classes.purple}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText16}`}>
                Congrès
              </Typography>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText17}`}>
                Hlm
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col5info1)}
              </Typography>
            </div>
            <div className={classes.purple}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText18}`}>
                Réseaux
              </Typography>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText19}`}>
                Pros
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col5info2)}
              </Typography>
            </div>
            <div className={classes.purple}>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col5info3)}
              </Typography>
            </div>
            <div className={classes.purple}>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col5info4)}
              </Typography>
            </div>
            <div className={classes.purple}>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col5info5)}
              </Typography>
            </div>
            <div className={classes.purple}>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col5info6)}
              </Typography>
            </div>
          </div>
        </div>
        <div className={`${classes.col} ${classes.col6}`}>
          <div></div>
          <div className={classes.group}>
            <div className={classes.purple}>
              <Typography variant="h2" className={`${classes.bgText} ${classes.bgText20}`}>
                Trophées
              </Typography>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col6info1)}
              </Typography>
            </div>
            <div className={classes.purple}>
              <Typography variant="body2" className={`bullet ${classes.bullet}  ${classes.text}`}>
                {parse(data.blocks.b4numbers.col6info2)}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, data } = this.props;
    const mainTitle = parse(data.blocks.b4numbers.mainTitle);
    const title = parse(data.blocks.b4numbers.title);
    return (
      <div className={classes.blockContainer}>
        <Typography variant="h1" color="secondary" className={classes.mainTitle}>
          {mainTitle}
        </Typography>
        <TypoFramed variant="h4" frame="white" className={classes.title}>
          {title}
        </TypoFramed>
        {this.renderBackground()}
        {this.renderContent()}
      </div>
    );
  }
}

B4Numbers.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default withStyles(styles)(B4Numbers);
